import { createSlice } from '@reduxjs/toolkit'

// collectors: {shipmentId: collectorType}
const initialState = {
  collectors: {}
}

export const collectorInformationSlice = createSlice({
  name: 'collectorInformation',
  initialState,
  reducers: {
    addCollector: (state, action) => {
      const {
        shipmentId,
        collectorType
      } = action.payload

      if (!shipmentId || !collectorType) return
      state.collectors = {
        ...state.collectors,
        [shipmentId]: collectorType
      }
    }
  }
})

export const { addCollector } = collectorInformationSlice.actions

export const selectCollectors = (state) => state.collectorInformation.collectors

export default collectorInformationSlice.reducer
